import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CategorySaveService {
    requestSave: Subject<void> = new Subject();
}